RivalIQ.apps.AccountSettings.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const views = {
        landscapes: {
            class: App.views.LandscapeEmailControl
        },
        details: {
            class: App.views.Edit.extend({
                template: '#userJoinTemplate'
            }),
            options: {
                fields: [
                    'name',
                    'password',
                    'gdpr'
                ]
            }
        }
    };

    const AccountStateMachine = Dashboard.models.StateMachine.extend({
        initialState: function () {
            return 'details';
        },

        events: function () {

            const me = this;
            let states = [
                ['details', 'landscapes', Dashboard.models.StateMachine.isValid],
                ['landscapes', '/overview', Dashboard.models.StateMachine.isValid]
            ];

            if (me.model.isReadOnly()) {
                // readonly users go directly to dashboards
                states = [
                    ['details', '/dashboards', Dashboard.models.StateMachine.isValid]
                ];
            }

            return {
                'sync': states
            };
        }
    });

    const Wizard = Dashboard.models.Wizard.extend({
        View: Dashboard.views.Wizard.extend({
            template: '#userWizardViewTemplate'
        }),
        StateMachine: AccountStateMachine,

        navigate: function () {
            const me = this;
            RivalIQ.execute('history:navigate', `/account/join/${me.getProp('state')}`);
        },

        // NOTE reload whole app b/c user is changing state
        executeTransition: function (state) {
            const me = this;

            if (state[0] === '/') {
                window.location = state;
                return;
            }

            me.setProps({
                state: state
            });
        }
    });

    const setModel = function (curation) {
        RivalIQ.execute('toggle:shell', false);

        return RivalIQ.data.users.fetch(RivalIQ.state.account, RivalIQ.state.user.get('id'))
            .then(function (user) {
                curation.model = user;
            });
    };

    const Layout = Marionette.LayoutView.extend({
        regions: {
            wizard: '.wizard-region'
        },
        template: function () {
            return '<div class="wizard-region"/>';
        },
        modelEvents: {
            'change': 'onBeforeShow'
        },
        onBeforeShow: function () {
            const me = this;
            const view = me.model.getWidgets();
            me.model.showViews(me.wizard, null, view, new $.Deferred());
        }
    });

    const showWizard = function (curation) {
        const wizard = _.extend(new Wizard({
            views: views
        }), {
            model: curation.model
        });

        return wizard.runFilters('beforeFilters').then(function () {
            return new Layout({
                model: wizard
            });
        });
    };

    curations.Join = Dashboard.models.Curation.extend({
        beforeFilters: [
            setModel,
            showWizard
        ],
        title: function () {
            const name = RivalIQ.state.account.get('name');
            return {
                name: ['Join', (name ? `${name} on ` : ''), 'Rival IQ'].join(' ')
            };
        }
    });

});
